export const BOOKING_WIZARD_ROUTE_PREFIX: string = '/dashboard/booking-wizard';

interface BookingWizardRoutes {
  draft: {
    getUrl: (draftReference: string) => string;
    path: string;
    relativePath: string;
  };
  index: {
    getUrl: () => string;
    path: string;
    relativePath: string;
  };
}

const bookingWizardRoutes: BookingWizardRoutes = {
  draft: {
    getUrl: (draftReference: string): string => `${BOOKING_WIZARD_ROUTE_PREFIX}/${draftReference}`,
    path: `${BOOKING_WIZARD_ROUTE_PREFIX}/:draftReference`,
    relativePath: 'booking-wizard/:draftReference'
  },
  index: {
    getUrl: (): string => BOOKING_WIZARD_ROUTE_PREFIX,
    path: BOOKING_WIZARD_ROUTE_PREFIX,
    relativePath: 'booking-wizard'
  }
};

export default bookingWizardRoutes;
